import React from 'react';
import { Typography, Flex, Tag } from 'antd';
import * as AntdIcons from '@ant-design/icons';

import { userInfoStruct } from './struct';

const { Text, Title } = Typography;
const {
  user: userStruct,
  userEmail,
  userName,
  userDepartment,
  userDesignation,
  userSchool
} = userInfoStruct;

export const UserInfo = ({ user }) => {
  // const { name, designation, department, school, email, role, school_short_name } = user || {};
  const { name, designation, department, school, email } = user || {};

  if (!user) {
    return null
  }

  return (
    user && (
      <Flex {...userStruct}>
        {/* <Flex gap={2} align="center" wordBreak='break-word'>
          <Title {...userName}>{name ? name.toUpperCase() + ',' : ''}</Title>
          <Title style={{ textTransform: 'capitalize' }} {...userName}>{" "}{role + ','}</Title>
          <Title style={{ textTransform: 'capitalize' }} {...userName}>{" "}{school_short_name}</Title>
        </Flex> */}

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, alignItems: 'center' }}>
          <Title {...userName} style={{ whiteSpace: 'nowrap', marginBottom: 0 }}>
            {name ? name.toUpperCase() : ''}
          </Title>
          {/* <Title {...userName} style={{ textTransform: 'capitalize', whiteSpace: 'nowrap', marginBottom: 0 }}>
            {role + ','}
          </Title>
          <Title {...userName} style={{ textTransform: 'capitalize', whiteSpace: 'nowrap', marginBottom: 0 }}>
            {school_short_name}
          </Title> */}
        </div>

        <Tag {...userEmail}>
          <AntdIcons.MailOutlined />
          <Text>{email}</Text>
        </Tag>
        <Tag {...userDesignation}>
          <AntdIcons.CrownOutlined />
          <Text>{designation}</Text>
        </Tag>
        <Tag {...userDepartment}>
          <AntdIcons.PartitionOutlined />
          <Text>{department}</Text>
        </Tag>
        <Text {...userSchool}>{school}</Text>
      </Flex>
    )
  );
};
